import React from 'react';

import { useRovodalStoreState } from '@atlassian/rovodal-context/use-rovodal-store-state';

import { type ConversationAssistantConfig } from '../../types';

import { InsideRovodalContext } from './insideRovodalContext';
import { RovodalHostEntry } from './RovodalHostEntry';

type RovodalHostProps = {
	config: ConversationAssistantConfig;
};

/*
Generic host: only ever mounts a single Rovodal. It renders the first open
entry in the store, regardless of which consumer opened it. The canvas is
resolved via the registry inside RovodalHostEntry.

Renders null when already inside a Rovodal, so the chat mounted within a
Rovodal (which itself mounts a RovodalHost) cannot recurse into more Rovodals.

TBD: If we have a new action when already in a rovodal for a different action and want to surface that
*/
export const RovodalHost = ({ config }: RovodalHostProps): React.JSX.Element | null => {
	const insideRovodal = React.useContext(InsideRovodalContext);
	const { byKey } = useRovodalStoreState();

	const openEntry = Object.values(byKey)
		.flatMap((instances) => Object.values(instances))
		.find((entry) => entry.isOpen);

	if (insideRovodal || !openEntry) {
		return null;
	}

	return (
		<RovodalHostEntry
			rovodalKey={openEntry.key}
			instanceId={openEntry.instanceId}
			config={config}
		/>
	);
};
